"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readValidationMetadata = exports.Ignore = exports.VALIDATION_METADATA_SYM = exports.UpperCase = exports.LowerCase = exports.Trim = exports.TryParseNumber = exports.ReadonlyGetter = void 0;
const transformer_1 = require("./transformer");
function ReadonlyGetter() {
    return (target, propertyKey) => {
        transformer_1.Expose({ toPlainOnly: true })(target, propertyKey);
        transformer_1.Exclude({ toClassOnly: true })(target, propertyKey);
    };
}
exports.ReadonlyGetter = ReadonlyGetter;
function TryParseNumber() {
    return transformer_1.Transform((value) => {
        const parsedNumber = Number(value);
        if (!Number.isNaN(parsedNumber))
            return parsedNumber;
        else
            return value;
    });
}
exports.TryParseNumber = TryParseNumber;
function Trim() {
    return transformer_1.Transform((value) => {
        if (value == null)
            return value;
        else if (typeof value !== "string")
            throw new Error("A string was expected");
        else
            return value.trim();
    });
}
exports.Trim = Trim;
function LowerCase() {
    return transformer_1.Transform((value) => {
        if (value == null)
            return value;
        else if (typeof value !== "string")
            throw new Error("A string was expected");
        else
            return value.toLowerCase();
    });
}
exports.LowerCase = LowerCase;
function UpperCase() {
    return transformer_1.Transform((value) => {
        if (value == null)
            return value;
        else if (typeof value !== "string")
            throw new Error("A string was expected");
        else
            return value.toUpperCase();
    });
}
exports.UpperCase = UpperCase;
exports.VALIDATION_METADATA_SYM = Symbol("ValidationMetadata");
function Ignore() {
    return (target, property) => {
        var _a;
        const metadata = (_a = Reflect.getMetadata(exports.VALIDATION_METADATA_SYM, target.constructor)) !== null && _a !== void 0 ? _a : { ignore: {} };
        metadata.ignore[property] = true;
        Reflect.defineMetadata(exports.VALIDATION_METADATA_SYM, metadata, target.constructor);
    };
}
exports.Ignore = Ignore;
function readValidationMetadata(target) {
    const meta = Reflect.getMetadata(exports.VALIDATION_METADATA_SYM, target);
    return meta !== null && meta !== void 0 ? meta : null;
}
exports.readValidationMetadata = readValidationMetadata;
//# sourceMappingURL=custom.js.map